import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class BenefitsPackageModal extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#benefits-package-form-modal',
			triggerSelectors: ['.js-benefits-package-trigger'],
			stepsEndpointAttr: 'benefits-package-steps-endpoint',
			submitEndpointAttr: 'benefits-package-submit-endpoint',
			wrapperSelector: '.p-venue-registration-landing',
			sectionWrapperSelector: '.p-venue-registration-landing-wrapper',
			logPrefix: 'BenefitsPackageModal'
		});
	}

	init() {
		super.init();
		if (!this.stepsEndpoint) {
			this.stepsEndpoint = '/api/venueRegistration/benefitsPackage/singlesite/steps';
		}
		if (!this.submitEndpoint) {
			this.submitEndpoint = '/api/venueRegistration/benefitsPackage/singlesite/submit';
		}
	}

	getRequestParam() {
		const params = super.getRequestParam() || {};
		return {
			...params,
			mode: 'multiple'
		};
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.StepForm,
			exitButtonLabel: 'Save and Exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',		
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(BenefitsPackageModal);

export default BenefitsPackageModal;
